import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PathRoutes } from '../../core/configuration/pathRoutes';
import { LicenseCheckerService } from '../../core/helper/licenseChecker';

@Component({
  selector: 'app-redirect',
  template: ''
})
export class RedirectComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private licenseChecker: LicenseCheckerService
  ) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      const myReportinLicense = data['myReportin'];
      const hostelLicense = data['hostel'];
      const appLicense = data['app'];
      const appKlikticket = data['klikticket'];

      if (myReportinLicense) {
        this.redirectMyReportin();
      } else if (appLicense) {
        this.redirectApp();
      } else if (appKlikticket) {
        this.redirectKlikticket();
      } else {
        this.redirectHostel();
      }
    });
  }

  redirectMyReportin() {
    if (!this.licenseChecker.checkLicense('myreportin')) {
      window.open('https://www.myreportin.com/', '_blank');
    } else {
      window.open('https://app.myreportin.com/', '_blank');
    }
    window.history.back();
  }

  redirectKlikticket() {
    if (!this.licenseChecker.checkLicense('klikticket')) {
      window.open('https://www.klikticket.es', '_blank');
    } else {
      window.open('https://www.klikticket.es/registro/', '_blank');
    }
    window.history.back();
  }

  redirectApp() {
    const hasLivesHR = this.licenseChecker.checkLicense('livesHR');
    const hasAttendance = this.licenseChecker.checkLicense('attendance');

    if (!hasLivesHR && !hasAttendance) {
      this.router.navigate(['/home']);
      window.open('https://www.liveshr.com/', '_blank');
    }
  }

  redirectHostel() {
    if (!this.licenseChecker.checkLicense('hostelHR')) {
      this.router.navigate(['/home']);
      window.open('https://www.hostelhr.com/hostel-hr-hosteleria/', '_blank');
    }
  }
}
